<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">
                FAQ List
              </h3>
              <router-link
                :to="{ path: 'faq/create' }"
                class="float-right mt-0"
              >
                <v-tooltip
                  bottom
                  :color="$vuetify.theme.themes.light.tooltipColor"
                >
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add FAQ</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col>
                    <v-text-field
                      class="search-text-field"
                      v-model="search"
                      append-icon="search"
                      label="Search by Question"
                      single-line
                      hide-details
                      v-debounce:1s="searchFilter"
                      :debounce-events="['click', 'keydown']"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-col>
                  <v-btn @click="updateChanges">
                    <img class="mr-2"
                          width="24"
                          height="24"
                          src="@/assets/images/Edit.svg"
                        />
                     {{allowDrag ? 'Save' : 'Change order' }}
                   </v-btn>
                   <v-btn class="ml-2" v-if="allowDrag" @click="allowDrag=false">
                     Cancel
                   </v-btn>
                </v-col>            
              <v-data-table
                :headers="activeHeaders"
                :items="faq"
                ref="myTable"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:body="props">
                  <Draggable :list="props.items" tag="tbody" 
                  :disabled="!allowDrag"
                  @update="handleTableUpdate(props.items)">
                  <data-table-row-handler 
                    v-for="item in props.items" 
                    :key="item._id" 
                    :item="item"                   
                    :headers="activeHeaders">
               <template v-slot:[`item.order`]="{ item }">
              <div>{{props.items.indexOf(item) + 1}}</div>
              </template>
                <template v-slot:[`item.answer`]="{ item }">
                  <div class="answer-text" v-html="item.answer"></div>
                </template>
                <template v-slot:[`item.question`]="{ item }">
                  <div class="answer-text" v-html="item.question"></div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <router-link :to="{ path: 'faq/' + item._id }">
                    <v-tooltip
                      bottom
                      :color="$vuetify.theme.themes.light.tooltipColor"
                    >
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <img
                          v-bind="attrs"
                          v-on="{ ...tooltip }"
                          class="mr-2 edit-icon"
                          src="@/assets/images/Edit.svg"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>

                  <delete-component
                    :id="item._id"
                    module="faq/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                </template>
                    </data-table-row-handler>
                  </Draggable>
                </template>
              </v-data-table>

              <v-card-actions class="justify-end pt-2">
                <v-pagination
                  circle
                  v-model="page"
                  :length="pageCount"
                ></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import DeleteComponent from "@/components/DeleteComponent";
import DataTableRowHandler from "./DataTableRowHandler.vue";
import { faqService } from "@/services";
import Draggable from "vuedraggable";

export default {
  name: "FAQ",
  components: {
    CommonSection,
    DeleteComponent,
    DataTableRowHandler,
    Draggable
  },
  data: () => ({
    allowDrag: false,
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    faq: [],
    search: null,
    status: true,
    updatedFaq:[],
    statusArr: [
      {
        name: "All",
        value: "",
      },
      {
        name: "Active",
        value: true,
      },
      {
        name: "Inactive",
        value: false,
      },
    ],
    headers: [
      { text: "Order", value: "order", sortable: false },
      {
        text: "Question",
        align: "start",
        value: "question",
      },
      { text: "Answer", value: "answer" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  computed:{
    activeHeaders() {
      return this.headers.filter((h) => {
        if (!this.allowDrag && h.value === "order") {
         // console.log("false");
          return false;
        }
        return true;
      });
    },
  },
  methods: {
   async updateChanges(){     
    this.allowDrag = !this.allowDrag;    
      if(!this.allowDrag){
        this.loading = true;
        const promises = [];
        this.updatedFaq.forEach((item,index)=>{
          const obj =Object.assign({}, { 
            answer: item.answer, 
            question :  item.question,
            indexNumber :index+1
          });
          const deleteResponse = new Promise( (resolve,reject)=>{
           const response = faqService.updateFAQ({
            id: item._id,
            object: obj
          });          
          resolve(response);
        });
        promises.push(deleteResponse);
        })
        Promise.all(promises).then(()=>{
        this.initialize();
        })
      }
    },
    handleTableUpdate(item){
     this.updatedFaq = item;
     //console.log(item,'in handleTableUpdate')
    },
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        question: this.search,
      };
      const faqs = await faqService.faqList(params);
      if (faqs.data.data.length > 0) {
        this.pageCount = Math.ceil(
          faqs.data.option[0].count / this.itemsPerPage
        );
        this.faq = faqs.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.faq = [];
      }
    },
    searchFilter() {
      this.page = 1;
      this.initialize();
    },
    statusFilter() {
      this.page = 1;
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
    getColor(object) {
      if (object.isActive) {
        return "#30E362";
      } else if (object.isDelete) {
        return "red";
      } else {
        return "#5B5B5B";
      }
    },
  },
};
</script>
<style>
.answer-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
